import { Calculator } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Slider } from "@/components/ui/slider";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { money } from "@/lib/api";

export const CalcInputs = ({ price, setPrice, lbs, setLbs, tier, setTier, tiers }) => (
  <div className="space-y-6">
    <div className="space-y-2">
      <label className="text-sm font-bold flex items-center gap-2"><Calculator className="h-4 w-4 text-primary" />What you pay now per lb</label>
      <div className="relative">
        <span className="absolute left-4 top-1/2 -translate-y-1/2 font-bold text-primary">$</span>
        <Input type="number" min={0} inputMode="decimal" value={price} placeholder="Enter your price" onChange={(e) => setPrice(e.target.value)} data-testid="calculator-current-price-input"
          className="h-14 pl-8 rounded-xl text-lg font-bold border-2 border-primary ring-4 ring-primary/20 shadow-[0_0_24px_rgba(16,185,129,0.35)]" />
      </div>
      <p className="text-xs font-semibold text-primary" data-testid="calculator-helper-text">Enter your real price per lb.</p>
    </div>
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="text-sm font-bold">How many lbs</label>
        <span className="font-display text-lg font-extrabold text-primary" data-testid="calculator-lbs-value">{lbs} lbs</span>
      </div>
      <Slider min={1} max={50} step={1} value={[lbs]} onValueChange={(v) => setLbs(v[0])} data-testid="calculator-lbs-slider" />
      <div className="flex justify-between text-xs text-muted-foreground"><span>1</span><span>50</span></div>
    </div>
    <div className="space-y-2">
      <label className="text-sm font-bold">Membership tier</label>
      <Select value={tier} onValueChange={setTier}>
        <SelectTrigger className="h-12 rounded-xl" data-testid="calculator-tier-select"><SelectValue /></SelectTrigger>
        <SelectContent>
          {tiers.map((t) => <SelectItem key={t.key} value={t.key} data-testid={`calculator-tier-option-${t.key}`}>{t.name} {money(t.price)}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  </div>
);
